import { Link } from "react-router-dom";

const categories = [
  {
    to: "/news",
    icon: "ri-newspaper-line",
    title: "社区新闻",
    desc: "本地新闻与社区活动，第一时间了解身边动态",
    accent: "bg-primary-100 text-primary-700",
  },
  {
    to: "/forum",
    icon: "ri-chat-smile-2-line",
    title: "邻里论坛",
    desc: "求助帮忙、闲置转让、兴趣小组，邻里互动专区",
    accent: "bg-secondary-100 text-secondary-700",
  },
  {
    to: "/services",
    icon: "ri-hand-heart-line",
    title: "生活服务",
    desc: "家电维修、家政保洁、快递代收等生活信息汇总",
    accent: "bg-accent-100 text-accent-800",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      {categories.map((c) => (
        <Link
          key={c.to}
          to={c.to}
          className="group bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 hover:bg-background-100 transition-colors"
        >
          <span className={`w-11 h-11 rounded-lg flex items-center justify-center mb-4 ${c.accent}`}>
            <i className={`${c.icon} text-xl`}></i>
          </span>
          <h3 className="text-base font-bold text-foreground-950 flex items-center gap-1">
            {c.title}
            <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all"></i>
          </h3>
          <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{c.desc}</p>
        </Link>
      ))}
    </section>
  );
}